// import { useEffect, useState } from "react";
// import { supabase } from "../lib/supabaseclient";

// export default function AdminDashboard() {
//   const [activeTab, setActiveTab] = useState("orders");
//   const [orders, setOrders] = useState([]);
//   const [contacts, setContacts] = useState([]);
//   const [transfers, setTransfers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
//   const [deleteConfirm, setDeleteConfirm] = useState({ show: false, table: null, id: null });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false); // ✅ new state

//   // ✅ Fetch all tables on mount
//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   const fetchAllData = async () => {
//     setLoading(true);
//     const session = JSON.parse(sessionStorage.getItem("sb-session"));
//     if (!session) {
//       window.location.href = "/admin"; // redirect if not logged in
//       return;
//     }

//     try {
//       const [ordersRes, contactRes, transferRes] = await Promise.all([
//         supabase.from("orders").select("*").order("created_at", { ascending: false }),
//         supabase.from("contact_requests").select("*").order("created_at", { ascending: false }),
//         supabase.from("transfers").select("*").order("created_at", { ascending: false }),
//       ]);

//       setOrders(ordersRes.data || []);
//       setContacts(contactRes.data || []);
//       setTransfers(transferRes.data || []);
//     } catch (err) {
//       console.error("Unexpected fetch error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Handle delete with popup
//   const confirmDelete = async () => {
//     if (!deleteConfirm.table || !deleteConfirm.id) return;

//     const { error } = await supabase
//       .from(deleteConfirm.table)
//       .delete()
//       .eq("id", deleteConfirm.id);

//     if (error) {
//       console.error("❌ Delete failed:", error.message);
//     } else {
//       fetchAllData();
//       setShowSuccessPopup(true); // ✅ show popup
//       setTimeout(() => setShowSuccessPopup(false), 2000); // ✅ auto hide in 2s
//     }
//     setDeleteConfirm({ show: false, table: null, id: null });
//   };

//   const handleLogout = async () => {
//     await supabase.auth.signOut();
//     sessionStorage.removeItem("sb-session");
//     window.location.href = "/admin";
//   };

//   const currentData =
//     activeTab === "orders" ? orders : activeTab === "contact" ? contacts : transfers;

//   return (
//     <div className="min-h-screen bg-gray-100 flex flex-col">
//       {/* ✅ Top Navbar */}
//       <header className="bg-white shadow p-4 flex items-center justify-between">
//         <h1 className="text-2xl font-bold">Admin Dashboard</h1>

//         <nav className="flex space-x-4">
//           <button
//             onClick={() => setActiveTab("orders")}
//             className={`px-4 py-2 rounded-lg ${activeTab === "orders" ? "bg-blue-600 text-white" : "hover:bg-gray-200"
//               }`}
//           >
//             📦 Orders
//           </button>
//           <button
//             onClick={() => setActiveTab("contact")}
//             className={`px-4 py-2 rounded-lg ${activeTab === "contact" ? "bg-blue-600 text-white" : "hover:bg-gray-200"
//               }`}
//           >
//             📬 Contact Requests
//           </button>
//           <button
//             onClick={() => setActiveTab("transfers")}
//             className={`px-4 py-2 rounded-lg ${activeTab === "transfers" ? "bg-blue-600 text-white" : "hover:bg-gray-200"
//               }`}
//           >
//             🔁 Transfers
//           </button>
//         </nav>

//         <button
//           onClick={() => setShowLogoutConfirm(true)}
//           className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
//         >
//           Logout
//         </button>
//       </header>

//       {/* ✅ Main Content */}
//       <main className="flex-1 p-8">
//         <h2 className="text-2xl font-bold mb-6 capitalize">{activeTab} Data</h2>

//         {loading ? (
//           <p>Loading all data...</p>
//         ) : currentData.length === 0 ? (
//           <p>No {activeTab} data available.</p>
//         ) : (
//           <div className="overflow-x-auto bg-white rounded-lg shadow">
//             <table className="min-w-full text-sm">
//               <thead>
//                 <tr className="bg-gray-200 text-left">
//                   {Object.keys(currentData[0]).map((key) => (
//                     <th key={key} className="px-4 py-2 capitalize">
//                       {key.replaceAll("_", " ")}
//                     </th>
//                   ))}
//                   <th className="px-4 py-2">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentData.map((row) => (
//                   <tr key={row.id} className="border-t hover:bg-gray-50">
//                     {Object.keys(row).map((key) => (
//                       <td key={key} className="px-4 py-2 align-top">
//                         {key === "items" && Array.isArray(row.items) ? (
//                           <div className="border rounded-lg bg-gray-50 p-2">
//                             <table className="min-w-full text-xs">
//                               <thead>
//                                 <tr className="bg-gray-100">
//                                   <th className="px-2 py-1">Title</th>
//                                   <th className="px-2 py-1">Subtitle</th>
//                                   <th className="px-2 py-1">Qty</th>
//                                   <th className="px-2 py-1">Price</th>
//                                 </tr>
//                               </thead>
//                               <tbody>
//                                 {row.items.map((item, idx) => (
//                                   <tr key={idx}>
//                                     <td className="px-2 py-1">{item.title}</td>
//                                     <td className="px-2 py-1">{item.subtitle}</td>
//                                     <td className="px-2 py-1">{item.quantity}</td>
//                                     <td className="px-2 py-1">Rs{parseFloat(item.price).toFixed(2)}</td>
//                                   </tr>
//                                 ))}
//                               </tbody>
//                             </table>
//                           </div>
//                         ) : (
//                           <span>
//                             {(() => {
//                               const value = row[key];

//                               // ✅ Detect date fields (Supabase timestamps often have "created_at" or end with "_at")
//                               if (key.includes("created_at") || key.includes("updated_at") || key.endsWith("_at")) {
//                                 const date = new Date(value);
//                                 if (isNaN(date)) return String(value);

//                                 const day = date.toLocaleString("en-US", { weekday: "long" }); // Monday, Tuesday...
//                                 const dd = String(date.getDate()).padStart(2, "0"); // 01, 02...
//                                 const mm = String(date.getMonth() + 1).padStart(2, "0"); // 01-12
//                                 const yy = String(date.getFullYear()).slice(-2); // 25, 26...

//                                 return `${day}: ${dd}, ${mm}, ${yy}`;
//                               }

//                               // ✅ Handle price/total/amount numeric fields
//                               if (
//                                 typeof value === "number" &&
//                                 (key.includes("total") || key.includes("amount") || key.includes("price"))
//                               ) {
//                                 return `Rs${parseFloat(value).toFixed(2)}`;
//                               }

//                               // ✅ Handle arrays/objects safely
//                               if (typeof value === "object") {
//                                 return JSON.stringify(value);
//                               }

//                               return String(value);
//                             })()}
//                           </span>

//                         )}
//                       </td>
//                     ))}

//                     <td className="px-4 py-2">
//                       <button
//                         onClick={() =>
//                           setDeleteConfirm({
//                             show: true,
//                             table:
//                               activeTab === "orders"
//                                 ? "orders"
//                                 : activeTab === "contact"
//                                   ? "contact_requests"
//                                   : "transfers",
//                             id: row.id,
//                           })
//                         }
//                         className="text-red-600 hover:underline"
//                       >
//                         🗑 Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </main>

//       {/* ✅ Logout Confirmation Modal */}
//       {showLogoutConfirm && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg text-center space-y-4">
//             <h3 className="text-lg font-bold">Are you sure you want to logout?</h3>
//             <div className="flex justify-center gap-4">
//               <button
//                 onClick={handleLogout}
//                 className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
//               >
//                 Yes, Logout
//               </button>
//               <button
//                 onClick={() => setShowLogoutConfirm(false)}
//                 className="bg-gray-300 px-4 py-2 rounded-lg hover:bg-gray-400"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ✅ Delete Confirmation Modal */}
//       {deleteConfirm.show && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-lg text-center space-y-4">
//             <h3 className="text-lg font-bold">Are you sure you want to delete this record?</h3>
//             <div className="flex justify-center gap-4">
//               <button
//                 onClick={confirmDelete}
//                 className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
//               >
//                 Yes, Delete
//               </button>
//               <button
//                 onClick={() => setDeleteConfirm({ show: false, table: null, id: null })}
//                 className="bg-gray-300 px-4 py-2 rounded-lg hover:bg-gray-400"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ✅ Success Popup */}
//       {showSuccessPopup && (
//         <div className="fixed bottom-6 right-6 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in">
//           ✅ Record deleted successfully!
//         </div>
//       )}
//     </div>
//   );
// }


import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseclient";

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("orders");
  const [orders, setOrders] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, table: null, id: null });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // ✅ search state
  const [newOrdersBadge, setNewOrdersBadge] = useState(false);
  const [newContactsBadge, setNewContactsBadge] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const session = JSON.parse(sessionStorage.getItem("sb-session"));
    if (!session) {
      window.location.href = "/admin";
      return;
    }

    try {
      const [ordersRes, contactRes] = await Promise.all([
        supabase.from("orders").select("*").order("created_at", { ascending: false }),
        supabase.from("contact_requests").select("*").order("created_at", { ascending: false }),
      ]);

      const prevOrdersCount = parseInt(localStorage.getItem("ordersCount") || "0");
      const prevContactsCount = parseInt(localStorage.getItem("contactsCount") || "0");

      const currentOrdersCount = ordersRes.data?.length || 0;
      const currentContactsCount = contactRes.data?.length || 0;

      // ✅ Show badges if new records are detected
      setNewOrdersBadge(currentOrdersCount > prevOrdersCount);
      setNewContactsBadge(currentContactsCount > prevContactsCount);

      // ✅ Update localStorage counts
      localStorage.setItem("ordersCount", currentOrdersCount);
      localStorage.setItem("contactsCount", currentContactsCount);

      setOrders(ordersRes.data || []);
      setContacts(contactRes.data || []);
    } catch (err) {
      console.error("Unexpected fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = async () => {
    if (!deleteConfirm.table || !deleteConfirm.id) return;

    const { error } = await supabase
      .from(deleteConfirm.table)
      .delete()
      .eq("id", deleteConfirm.id);

    if (error) {
      console.error("❌ Delete failed:", error.message);
    } else {
      fetchData();
      setShowSuccessPopup(true);
      setTimeout(() => setShowSuccessPopup(false), 2000);
    }
    setDeleteConfirm({ show: false, table: null, id: null });
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    sessionStorage.removeItem("sb-session");
    window.location.href = "/admin";
  };

  const currentData = activeTab === "orders" ? orders : contacts;

  // ✅ Apply search filter
  const filteredData = currentData.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Top Navbar */}
      <header className="bg-white shadow p-4 flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-2xl font-bold">Admin Dashboard</h1>

        <nav className="flex space-x-4 flex-wrap items-center">
          <button
            onClick={() => setActiveTab("orders")}
            className={`px-4 py-2 rounded-lg flex items-center gap-2 ${activeTab === "orders" ? "bg-blue-600 text-white" : "hover:bg-gray-200"
              }`}
          >
            📦 Orders
            {newOrdersBadge && <span className="bg-red-600 text-white rounded-full px-2 py-0.5 text-xs">New</span>}
          </button>

          <button
            onClick={() => setActiveTab("contact")}
            className={`px-4 py-2 rounded-lg flex items-center gap-2 ${activeTab === "contact" ? "bg-blue-600 text-white" : "hover:bg-gray-200"
              }`}
          >
            📬 Contact Requests
            {newContactsBadge && <span className="bg-red-600 text-white rounded-full px-2 py-0.5 text-xs">New</span>}
          </button>
        </nav>

        <button
          onClick={() => setShowLogoutConfirm(true)}
          className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
        >
          Logout
        </button>
      </header>

      {/* Main Content */}
      <main className="flex-1 p-8">
        <div className="flex flex-col md:flex-row md:justify-between mb-4 gap-3 items-center">
          <h2 className="text-2xl font-bold mb-2 md:mb-0 capitalize">{activeTab} Data</h2>
          <input
            type="text"
            placeholder={`Search ${activeTab}...`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="px-4 py-2 border rounded-lg outline-none focus:ring-2 focus:ring-blue-500 w-full md:w-64"
          />
        </div>

        {loading ? (
          <p>Loading data...</p>
        ) : filteredData.length === 0 ? (
          <p>No {activeTab} data found.</p>
        ) : (
          <div className="overflow-x-auto bg-white rounded-lg shadow">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="bg-gray-200 text-left">
                  {Object.keys(filteredData[0]).map((key) => (
                    <th key={key} className="px-4 py-2 capitalize">
                      {key.replaceAll("_", " ")}
                    </th>
                  ))}
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((row) => (
                  <tr key={row.id} className="border-t hover:bg-gray-50">
                    {Object.keys(row).map((key) => (
                      <td key={key} className="px-4 py-2 align-top">
                        {key === "items" && Array.isArray(row.items) ? (
                          <div className="border rounded-lg bg-gray-50 p-2">
                            <table className="min-w-full text-xs">
                              <thead>
                                <tr className="bg-gray-100">
                                  <th className="px-2 py-1">Title</th>
                                  <th className="px-2 py-1">Subtitle</th>
                                  <th className="px-2 py-1">Qty</th>
                                  <th className="px-2 py-1">Price</th>
                                </tr>
                              </thead>
                              <tbody>
                                {row.items.map((item, idx) => (
                                  <tr key={idx}>
                                    <td className="px-2 py-1">{item.title}</td>
                                    <td className="px-2 py-1">{item.subtitle}</td>
                                    <td className="px-2 py-1">{item.quantity}</td>
                                    <td className="px-2 py-1">Rs{parseFloat(item.price).toFixed(2)}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <span>
                            {row[key] && typeof row[key] === "object" ? JSON.stringify(row[key]) : row[key]}
                          </span>
                        )}
                      </td>
                    ))}
                    <td className="px-4 py-2">
                      <button
                        onClick={() =>
                          setDeleteConfirm({
                            show: true,
                            table: activeTab === "orders" ? "orders" : "contact_requests",
                            id: row.id,
                          })
                        }
                        className="text-red-600 hover:underline"
                      >
                        🗑 Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        )}
      </main>

      {/* Logout Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center space-y-4">
            <h3 className="text-lg font-bold">Are you sure you want to logout?</h3>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleLogout}
                className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
              >
                Yes, Logout
              </button>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="bg-gray-300 px-4 py-2 rounded-lg hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {deleteConfirm.show && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center space-y-4">
            <h3 className="text-lg font-bold">Are you sure you want to delete this record?</h3>
            <div className="flex justify-center gap-4">
              <button
                onClick={confirmDelete}
                className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
              >
                Yes, Delete
              </button>
              <button
                onClick={() => setDeleteConfirm({ show: false, table: null, id: null })}
                className="bg-gray-300 px-4 py-2 rounded-lg hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="fixed bottom-6 right-6 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in">
          ✅ Record deleted successfully!
        </div>
      )}
    </div>
  );
}
